<template>
    <div class="container" v-show="isVisible()">
        <form @submit.prevent="save">
            <div class="card">
                <div class="card-header"><h1 class="text-center">{{ question }}</h1></div>
                <div class="card-body">
                    <slot></slot>
                </div>
                <div class="card-footer">
                    <button type="submit" class="btn btn-primary btn-block">Save</button>
                </div>
            </div>
            <br>
            <div class="btn-group container" role="group">
                <button type="button" v-on:click="onPrev()" class="btn btn-secondary" :disabled="this.$parent.$attrs.prev === undefined">&lt; Back</button>          
                <button type="button" v-on:click="onNext()" class="btn btn-secondary" :disabled="this.$parent.$attrs.next === undefined || nextDisabled === true">Next &gt;</button>      
            </div>
        </form>

    </div>
</template>

<script>

export default {
  name: 'Question',
  props: {
      question: String,
      canGoBack: {
          type:Boolean,
          default: true
      }
  },
  methods: {
      save: function() {
        this.$parent.$emit('save');
        this.nextDisabled = false;
        this.onNext();
      },
      onNext: function() {
        let next = this.$parent.$attrs.next
        if (next === undefined) {
            // eslint-disable-next-line
            console.warn("No next defined");
        } else {
            this.$parent.$parent.$emit('setCurrentQuestion', next);
        }
      },
      onPrev: function() {
        let prev = this.$parent.$attrs.prev;
        if (prev === undefined) {
            // eslint-disable-next-line
            console.warn("No prev defined");
        } else {
            this.$parent.$parent.$emit('setCurrentQuestion', prev);
        }          
      },
      isVisible: function(){
        return this.$parent.$attrs.show === this.$parent.$parent.currentQuestion;
      }
  },
  data: function() {
      return {
          "nextDisabled" : true
      }
  }
}
</script>